/**
 * Базовый класс для всех ошибок HTTP-запросов, которые возвращает classifyError.
 */
export default class ApiException extends Error {
	constructor(message: string) {
		super(message);
		
		this.name = new.target.name;
	}
}
